/**
 * Delete project dialog — confirmation step before issuing the destructive
 * call. Phase-2 stub.
 */
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useWorkspaceData } from "@/hooks/use-workspace-data";

export interface DeleteProjectDialogProps {
  projectId: string | null;
  projectName?: string;
  onOpenChange: (open: boolean) => void;
}

export function DeleteProjectDialog({
  projectId,
  projectName,
  onOpenChange,
}: DeleteProjectDialogProps): JSX.Element {
  const deleteProject = useWorkspaceData((s) => s.deleteProject);

  async function confirm(): Promise<void> {
    if (!projectId) return;
    try {
      await deleteProject({ id: projectId });
      onOpenChange(false);
    } catch {
      // phase_2 toast already shown
    }
  }

  return (
    <Dialog open={projectId !== null} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete project?</DialogTitle>
          <DialogDescription>
            This will permanently remove{" "}
            <span className="font-medium text-foreground">{projectName ?? "this project"}</span>{" "}
            along with its history, comments, and comments on tracked issues.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={() => void confirm()}>
            Delete project
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
